import "./LaserEngravingMetal.module.css";
import Header from "@/reusable_sections/Header";
import ServiceHeroMetal from "./sections/ServiceHeroMetal";
import TechnicalOverview from "./sections/TechnicalOverview";
import MaterialFinishOptions from "./sections/MaterialFinishOptions";
import Capabilities from "./sections/Capabilities";
import HowToOrder from "./sections/HowToOrder";
import StandardsCertifications from "./sections/StandardsCertifications";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function LaserEngravingMetalPage() {
  return <div>
      <Header />
      <ServiceHeroMetal />
      <TechnicalOverview />
      <MaterialFinishOptions />
      <Capabilities />
      <HowToOrder />
      <StandardsCertifications />
      <Faq />
      <CallToAction />
      <Footer />
    </div>;
}